/**
 * @generated SignedSource<<f953791ed40db10edcb90d4a3c30e532>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_AssignPricingMutation$variables = {
  pricingId: string;
  productIds: ReadonlyArray<number>;
};
export type productSidePanelContent_AssignPricingMutation$data = {
  readonly assignProductsToPricing: {
    readonly result: boolean;
  };
};
export type productSidePanelContent_AssignPricingMutation = {
  response: productSidePanelContent_AssignPricingMutation$data;
  variables: productSidePanelContent_AssignPricingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pricingId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "pricingId",
        "variableName": "pricingId"
      },
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "assignProductsToPricing",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_AssignPricingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "productSidePanelContent_AssignPricingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2cd102c5eeb0da724b33d21c6986461d",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_AssignPricingMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_AssignPricingMutation(\n  $pricingId: ID!\n  $productIds: [Long!]!\n) {\n  assignProductsToPricing(pricingId: $pricingId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "5525be5636983a4298d61dadcff1c9c0";

export default node;
